import React from 'react';
import MainParticipant from '../MainParticipant/MainParticipant';

export default function Room() {
  return <MainParticipant />;
}
